import { Fragment, useState } from 'react';

import _ from 'lodash';
import ImageGallery from 'react-image-gallery';
import { useDispatch } from 'react-redux';

import CircularProgress from '@material-ui/core/CircularProgress';

import ImagesComponent from './ImagesComponent';
import classes from './PropertyItem.module.css';

import AddIcon from '../../assets/img/properties-choices/addIcon.svg';
import RemoveIcon from '../../assets/img/properties-choices/remove_24px.svg';
import useAddShortlistedoption from '../../store/contexts/useAddShortlistedoption';
import useIsShortlisted from '../../store/contexts/useIsShortlisted';
import { strToArray } from '../../utils/utils';
import HeartIcon from '../Core/CustomIcons/HeartIcon';

const PropertyItem = ({ option, onShortListed, inProgressV }) => {
  const res = useIsShortlisted(option.optionId);
  const [isSelected, setIsSelected] = useState(option?.shortListed);

  const dispatch = useDispatch();

  const { putOption, inProgress } = useAddShortlistedoption(option);

  const addToShortlist = () => {
    putOption(() => {
      setIsSelected(true);
      dispatch({ type: 'SET_ISSHORTLISTED', id: option.id, val: true });
      onShortListed('ADD');
    }, 'ADD');
  };

  const onClick2 = _.debounce(addToShortlist, 1000, true);

  const deleteFromShortlist = () => {
    putOption(() => {
      setIsSelected(false);
      dispatch({ type: 'SET_ISSHORTLISTED', id: option.id, val: false });
      dispatch({ type: 'DESELECT', id: option.id });
      onShortListed('REMOVE');
    }, 'REMOVE');
  };

  const preText = 'https://d1muf25xaso8hp.cloudfront.net/https%3A%2F%2F';
  const images1 = [];

  option.customImages &&
    option.customImages.map((image) =>
      images1.push({
        original: preText + encodeURI(image).split('//')[1],
      }),
    );

  return (
    <Fragment>
      <div className={classes.property}>
        <div className={classes.fav}>
          <HeartIcon
            color={isSelected ? '#FF543E' : '#778F9C'}
            onClick={isSelected ? deleteFromShortlist : onClick2}
          />
        </div>
        <div className={classes['images__wrapper']}>
          <ImagesComponent images={strToArray(option.images)} width="180px" height="110px" />
        </div>

        <p className={classes.optionName}>{option.optionName}</p>
        {!isSelected ? (
          <div className="btn" onClick={addToShortlist}>
            <div style={{ marginBottom: '2px' }}>
              <img src={AddIcon} />
            </div>
            <div>Add</div>
          </div>
        ) : (
          <div className="shortlistedBtn" onClick={deleteFromShortlist}>
            <div className={classes.icon_block}>
              <img src={RemoveIcon} />
            </div>
            <div>Remove</div>
          </div>
        )}

        {inProgress && (
          <span className={classes.spinner}>
            <CircularProgress color="inherit" />
          </span>
        )}
      </div>
    </Fragment>
  );
};

export default PropertyItem;
